import React, { useState } from "react";
import CommonModal from "../CommonModal";
import UsersListing from "../../Pages/Admin/Users/UsersListing";
import AddUserForm from "../../Pages/Admin/Users/AddUserForm";
import "../../Admin/Shared/AdminModal.css";

const OrgUsersModal = ({ openModal, closeModal, companyId, title, type }) => {
  const [show, setShow] = useState("list");
  const [selectedUser, setSelectedUser] = useState({});

  const handleAddUser = () => {
    setSelectedUser({});
    setShow("form");
  };

  const setData = (data) => {
    setSelectedUser(data);
    setShow("form");
  };

  return (
    <CommonModal
      title={`User Management ${title}`}
      modalStatus={openModal}
      changeActiveStatus={() => closeModal()}
      classList="admin-modal admin-org-users-modal"
      centered
      showFooter={false}
    >
      {show === "list" ? (
        <div className="user-list-view">
            <UsersListing
              showCheckbox={false}
              setData={setData}
              companyId={companyId}
              type={type}
            />
          {type === "userManagement" && (
            <div className="admin-list-footer">
              <button
                type="button"
                className="admin-cta-button"
                onClick={handleAddUser}
              >
                + ADD User
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="user-form-view">
          <AddUserForm
            setShow={setShow}
            companyId={companyId}
            selectedUser={selectedUser}
          />
        </div>
      )}
    </CommonModal>
  );
};
export default OrgUsersModal;
